import { slugify } from '@basehub/utils/case/index'

export function slugifyBranchName(name: string) {
  return slugify(name, { preserve: new Set(['/']) })
}
